export default function WhyFourLab() {
  const points = [
    {
      icon: 'ri-flask-line',
      title: '연구 중심 R&D 조직',
      description: '단순 개발이 아닌 연구개발 기반의 기술 수행',
    },
    {
      icon: 'ri-government-line',
      title: '공공·기업 과제 경험',
      description: '정부 및 공공 프로젝트 다수 수행 경험',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: '문제 해결 중심 접근',
      description: '기술 나열이 아닌 실질적 해결책 제시',
    },
  ];

  return (
    <section className="py-36 bg-gradient-to-b from-[#F0FDFA] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-20 text-center">
          <span className="text-sm font-medium text-[#0F766E] mb-3 block">차별화 포인트</span>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-6">
            왜 4-lab인가
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {points.map((point, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-10 border border-[#99F6E4]/30 text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mx-auto mb-6">
                <i className={`${point.icon} text-4xl text-[#0D9488]`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{point.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
